export default function sendCustomEvent(event, value = null) {
  if (!window.dataLayer) return;
  window.dataLayer.push({ event, value });
}
